import { createFileRoute } from '@tanstack/react-router';
import { lazy } from '@loadable/component';
import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

const GeneralCountersTable = lazy(
    async () =>
        (await import(/* webpackChunkName: "Counters" */ '@mews-commander/counters/components/GeneralCountersTable'))
            .GeneralCountersTable
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Counters/Bill')({
    component: () => <GeneralCountersTable counterTypes={[EnterpriseScopeCounterDiscriminator.BillCounter]} />,
    staticData: {
        title: TextKey.BillCounterPlural,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
